import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IConversationAiControlStateApi } from "@interfaces/IConversationAiControlStateApi.ts"
import { IConversationAiControlStateCli } from "@interfaces/IConversationAiControlStateCli.ts"

export const ConversationAiControlAdapter = (
	response: IApiResponse<IConversationAiControlStateApi>
): IConversationAiControlStateCli => response.data
